import { TMeetingNotificationData } from '@fsd-widgets/online-lesson-notifications';
import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
export interface IOLState {
    meetingNotificationsList?: TMeetingNotificationData[];
    collapsedNotificationsList: string[];
}

const initialState: IOLState = {
    collapsedNotificationsList: [],
};

const onlineLessonSlice = createSlice({
    name: 'onlineLesson',
    initialState,
    reducers: {
        setMeetingNotificationsList: (state, { payload }: { payload: TMeetingNotificationData[] }) => {
            state.meetingNotificationsList = payload?.filter(({ datetimeEnd }) => {
                return dayjs().isBefore(dayjs(datetimeEnd));
            });
        },
        deleteNotificationFromListByUrl: (state, { payload }: { payload: { url: string } }) => {
            state.meetingNotificationsList = state.meetingNotificationsList?.filter(({ url }) => url !== payload.url);
        },
        setCollapsedNotificationsList: (state, { payload }: { payload: string[] }) => {
            state.collapsedNotificationsList = payload;
        },
    },
    /**
     *
     * @param builder
     */
    extraReducers: (builder) => {},
});
export const {
    setMeetingNotificationsList,
    deleteNotificationFromListByUrl,
    setCollapsedNotificationsList,
} = onlineLessonSlice.actions;

export const onlineLessonsReducer = onlineLessonSlice.reducer;
